import { Link } from "react-router-dom";

import imgGRP2650 from "../assets/grandstream-grp2650.png";
import imgGRP2614 from "../assets/grandstream-grp2614.png";
import imgGRP2624 from "../assets/grandstream-grp2624.png";
import imgGRP2612 from "../assets/grandstream-grp2612.png";
import imgGRP2601 from "../assets/grandstream-grp2601.png";
import imgDP755 from "../assets/grandstream-dp755.png";
import imgGBX20 from "../assets/grandstream-gbx20.png";

import imgYHS34 from "../assets/yealink-yhs34.png";
import imgEvolve20Mono from "../assets/jabra-evolve20se-mono.png";
import imgEvolve20Duo from "../assets/jabra-evolve20se-duo.png";
import imgEngage50 from "../assets/jabra-engage50ii-duo.png";
import imgEvolve250 from "../assets/jabra-evolve2-50-duo.png";
import imgEvolve255M from "../assets/jabra-evolve2-55-mono.png";
import imgEvolve255D from "../assets/jabra-evolve2-55-duo.png";
import imgEvolve265 from "../assets/jabra-evolve2-65-flex.png";
import imgEvolve285 from "../assets/jabra-evolve2-85-duo.png";

const phones = [
  {
    name: "Grandstream GRP2650",
    tag: "WiFi + Bluetooth",
    img: imgGRP2650,
    price: "338 $",
    rent: "8,85 $/mois",
    lines: "14 touches de ligne",
    sip: "6 comptes SIP",
    blf: "56 touches BLF numériques intégrées",
    specs: [
      [
        "Affichage graphique",
        "Écran LCD couleur (1 280 x 720) TFT de 5 pouces",
      ],
      [
        "WiFi",
        "Oui, Wi-Fi 802.11 bibande intégré a/b/g/n/ac (2,4 GHz et 5 GHz)",
      ],
      ["Bluetooth", "Oui, intégré"],
      ["Port auxiliaire", "RJ9, USB"],
      [
        "Audio HD",
        "Oui. Combiné et haut-parleur HD prenant en charge l'audio à large bande, et un microphone double",
      ],
      ["Module d'extension", "Oui, GBX20"],
    ],
  },
  {
    name: "Grandstream GRP2614",
    tag: "WiFi + Bluetooth",
    img: imgGRP2614,
    price: "298 $",
    rent: "7,30 $/mois",
    lines: "4 touches de ligne",
    sip: "4 comptes SIP",
    blf: "40 touches BLF numériques intégrées",
    specs: [
      [
        "Affichage graphique",
        "Écran LCD couleur (320×240) TFT de 2,8 pouces et 2,4 pouces (240×320)",
      ],
      [
        "WiFi",
        "Oui, Wi-Fi 802.11 bibande intégré a/b/g/n/ac (2,4 GHz et 5 GHz)",
      ],
      ["Bluetooth", "Oui, intégré"],
      ["Port auxiliaire", "RJ9"],
      [
        "Audio HD",
        "Oui. Combiné et haut-parleur HD prenant en charge l'audio à large bande, et un microphone double",
      ],
      [
        "Module d'extension",
        "Non. Extensions disponibles sur le deuxième écran",
      ],
    ],
  },
  {
    name: "Grandstream GRP2624",
    tag: "WiFi + Bluetooth",
    img: imgGRP2624,
    price: "238 $",
    rent: "5,85 $/mois",
    lines: "8 touches de ligne",
    sip: "4 comptes SIP",
    blf: "32 touches BLF numériques intégrées",
    specs: [
      ["Affichage graphique", "Écran LCD couleur (320×240) TFT de 2,8 pouces"],
      [
        "WiFi",
        "Oui, Wi-Fi 802.11 bibande intégré a/b/g/n/ac (2,4 GHz et 5 GHz)",
      ],
      ["Bluetooth", "Oui, intégré"],
      ["Port auxiliaire", "RJ9, USB"],
      [
        "Audio HD",
        "Oui. Combiné et haut-parleur HD prenant en charge l'audio à large bande, et un microphone double",
      ],
      ["Module d'extension", "Oui, GBX20"],
    ],
  },
  {
    name: "Grandstream GRP2612",
    tag: "Téléphone IP standard",
    img: imgGRP2612,
    price: "172 $",
    rent: "4,10 $/mois",
    lines: "4 touches de ligne",
    sip: "2 comptes SIP",
    blf: "16 touches BLF numériques intégrées",
    specs: [
      ["Affichage graphique", "Écran LCD couleur (320×240) TFT de 2,4 pouces"],
      ["WiFi", "Non"],
      ["Bluetooth", "Non"],
      ["Port auxiliaire", "RJ9"],
      [
        "Audio HD",
        "Oui. Combiné et haut-parleur HD prenant en charge l'audio à large bande",
      ],
      ["Module d'extension", "Non"],
    ],
  },
  {
    name: "Grandstream GRP2601",
    tag: "Téléphone IP entrée de gamme",
    img: imgGRP2601,
    price: "122 $",
    rent: "3,10 $/mois",
    lines: "2 lignes sans touche",
    sip: "2 comptes SIP",
    blf: "0 touches BLF",
    specs: [
      ["Affichage graphique", "Écran LCD (132 × 48) de 2,21 pouces"],
      ["WiFi", "Non"],
      ["Bluetooth", "Non"],
      ["Port auxiliaire", "RJ9"],
      ["Audio HD", "Non"],
      ["Module d'extension", "Non"],
    ],
  },
  {
    name: "Grandstream DP755 + DP722",
    tag: "Combiné sans-fil DECT",
    img: imgDP755,
    price: "228 $",
    rent: "5,50 $/mois",
    lines: "20 lignes sans touche",
    sip: "20 comptes SIP",
    blf: "Portée 350 m extérieur / 50 m intérieur",
    specs: [
      ["Affichage graphique", "Écran LCD couleur (128×160) TFT de 1,8 pouce"],
      ["WiFi", "Non"],
      ["Bluetooth", "Non"],
      ["Port auxiliaire", "Prise casque 3,5 mm"],
      [
        "Audio HD",
        "Oui. Combiné et haut-parleur HD prenant en charge l'audio à large bande",
      ],
      [
        "Module d'extension",
        "Combiné DP722 supplémentaire — achat 130 $ / location flex 3,15 $/mois",
      ],
    ],
  },
  {
    name: "Grandstream GBX20",
    tag: "Module d'extension",
    img: imgGBX20,
    price: "235 $",
    rent: "5,90 $/mois",
    lines: "Compatible GRP2650 et GRP2624",
    sip: "Touches BLF supplémentaires",
    blf: "Ajoute fonctionnalité et flexibilité au poste principal",
    specs: [
      ["Compatibilité", "Téléphones IP GRP2650 et GRP2624"],
      ["Fonction", "Ajoute des touches de fonction et BLF supplémentaires"],
      ["Installation", "Se raccorde directement au combiné principal"],
    ],
  },
];

const headsets = [
  {
    name: "Yealink YHS34",
    tag: "Casque filaire — RJ9",
    img: imgYHS34,
    price: "68 $",
    rent: "2,20 $/mois",
    specs: [
      ["Audio", "Large bande Mono"],
      ["Connectivité", "RJ9"],
      ["Voyant d'occupation", "Non"],
      ["Réduction de bruit active (ANC)", "Non"],
    ],
  },
  {
    name: "Jabra Evolve 20SE Mono",
    tag: "Casque filaire — USB",
    img: imgEvolve20Mono,
    price: "82 $",
    rent: "3,05 $/mois",
    specs: [
      ["Audio", "Large bande Mono"],
      ["Connectivité", "USB"],
      ["Voyant d'occupation", "Oui"],
      ["Réduction de bruit active (ANC)", "Non"],
    ],
  },
  {
    name: "Jabra Evolve 20SE Duo",
    tag: "Casque filaire — USB",
    img: imgEvolve20Duo,
    price: "96 $",
    rent: "3,20 $/mois",
    specs: [
      ["Audio", "Large bande Stéréo"],
      ["Connectivité", "USB"],
      ["Voyant d'occupation", "Oui"],
      ["Réduction de bruit active (ANC)", "Non"],
    ],
  },
  {
    name: "Jabra Engage 50 II Duo",
    tag: "Casque filaire — USB",
    img: imgEngage50,
    price: "198 $",
    rent: "5,85 $/mois",
    specs: [
      ["Audio", "Large bande Stéréo"],
      ["Connectivité", "USB"],
      ["Voyant d'occupation", "Oui"],
      ["Réduction de bruit active (ANC)", "Non"],
    ],
  },
  {
    name: "Jabra Evolve2 50 Duo",
    tag: "Casque filaire — USB + Bluetooth",
    img: imgEvolve250,
    price: "248 $",
    rent: "7,50 $/mois",
    specs: [
      ["Audio", "Large bande Stéréo"],
      ["Connectivité", "USB, auxiliaire Bluetooth"],
      ["Voyant d'occupation", "Oui"],
      ["Réduction de bruit active (ANC)", "Oui"],
    ],
  },
  {
    name: "Jabra Evolve2 55 Mono",
    tag: "Casque sans-fil Bluetooth",
    img: imgEvolve255M,
    price: "395 $",
    rent: "11,85 $/mois",
    specs: [
      ["Audio", "Large bande Mono"],
      ["Connectivité", "Bluetooth"],
      ["Voyant d'occupation", "Oui"],
      ["Réduction de bruit active (ANC)", "Oui"],
    ],
  },
  {
    name: "Jabra Evolve2 55 Duo",
    tag: "Casque sans-fil Bluetooth",
    img: imgEvolve255D,
    price: "395 $",
    rent: "12,00 $/mois",
    specs: [
      ["Audio", "Large bande Stéréo"],
      ["Connectivité", "Bluetooth"],
      ["Voyant d'occupation", "Oui"],
      ["Réduction de bruit active (ANC)", "Oui"],
    ],
  },
  {
    name: "Jabra Evolve2 65 Flex",
    tag: "Casque sans-fil Bluetooth — Micro rétractable",
    img: imgEvolve265,
    price: "470 $",
    rent: "14,00 $/mois",
    specs: [
      ["Audio", "Large bande Stéréo"],
      ["Connectivité", "Bluetooth"],
      ["Voyant d'occupation", "Oui"],
      ["Réduction de bruit active (ANC)", "Oui"],
      ["Information supp.", "Micro rétractable"],
    ],
  },
  {
    name: "Jabra Evolve2 85 Duo",
    tag: "Casque sans-fil Bluetooth — Micro rétractable",
    img: imgEvolve285,
    price: "690 $",
    rent: "21,00 $/mois",
    specs: [
      ["Audio", "Large bande Stéréo"],
      ["Connectivité", "Bluetooth"],
      ["Voyant d'occupation", "Oui"],
      ["Réduction de bruit active (ANC)", "Oui"],
      ["Information supp.", "Micro rétractable"],
    ],
  },
];

function EquipCard({ p }) {
  return (
    <div className="equip-card h-100">
      <div className="equip-img">
        <img src={p.img} alt={p.name} className="equip-photo" />
      </div>
      <div className="p-4">
        <h3 className="h5 fw-bold mb-1">{p.name}</h3>
        <p className="small text-secondary mb-3">{p.tag}</p>

        <div className="d-flex gap-3 mb-3">
          <div>
            {/* <p className="font-mono small text-secondary mb-0">ACHAT</p>*/}
            <p className="fw-bold mb-0 text-brand">{p.price}</p>
          </div>
        </div>

        {p.lines && (
          <ul className="list-unstyled small text-secondary mb-3">
            <li>
              <i className="bi bi-check2 text-brand me-1"></i>
              {p.lines}
            </li>
            <li>
              <i className="bi bi-check2 text-brand me-1"></i>
              {p.sip}
            </li>
            <li>
              <i className="bi bi-check2 text-brand me-1"></i>
              {p.blf}
            </li>
          </ul>
        )}

        <dl className="small mb-0">
          {p.specs.map(([label, value]) => (
            <div key={label} className="mb-2">
              <dt className="fw-bold d-inline">{label} : </dt>
              <dd className="d-inline text-secondary">{value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}

export default function TelephonieEquipements() {
  return (
    <>
      <section className="section pb-3">
        <div className="container text-center" data-aos="fade-up">
          <span className="eyebrow">Téléphonie &middot; Équipements</span>
          <h1
            className="fw-900 mt-3 display-5"
            style={{ maxWidth: "760px", margin: "0 auto" }}
          >
            De l'équipement <span className="text-brand">haut de gamme</span>{" "}
            qui répond à vos besoins spécifiques
          </h1>
          <p
            className="lead text-secondary mt-3"
            style={{ maxWidth: "680px", margin: "0 auto" }}
          >
            On propose des téléphones IP, combinés sans-fil et casques
            Grandstream et Jabra, à l'achat ou en location flexible — avec
            l'installation et la configuration incluses dans nos forfaits.
          </p>
        </div>
      </section>
      <br />
      <br />
      <br />

      {/* TÉLÉPHONES */}
      <section className="section pt-0">
        <div className="container">
          <div
            className="d-flex align-items-center gap-3 mb-4"
            data-aos="fade-up"
          >
            <div className="service-icon" style={{ flexShrink: 0 }}>
              <i className="bi bi-telephone-fill"></i>
            </div>
            <div>
              <span className="eyebrow mb-0">Postes téléphoniques</span>
              <h2 className="fw-900 mb-0">Téléphones IP</h2>
            </div>
          </div>

          <div className="row g-4">
            {phones.map((p, i) => (
              <div
                className="col-md-4"
                key={p.name}
                data-aos="fade-up"
                data-aos-delay={(i % 3) * 100}
              >
                <EquipCard p={p} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CASQUES */}
      <section className="section pt-0">
        <div className="container">
          <div
            className="d-flex align-items-center gap-3 mb-4"
            data-aos="fade-up"
          >
            <div className="service-icon" style={{ flexShrink: 0 }}>
              <i className="bi bi-headset"></i>
            </div>
            <div>
              <span className="eyebrow mb-0">Audio professionnel</span>
              <h2 className="fw-900 mb-0">Casques d'écoute</h2>
            </div>
          </div>

          <div className="row g-4">
            {headsets.map((p, i) => (
              <div
                className="col-md-4"
                key={p.name}
                data-aos="fade-up"
                data-aos-delay={(i % 3) * 100}
              >
                <EquipCard p={p} />
              </div>
            ))}
          </div>

          <p className="text-secondary small mt-4 mb-0 text-center">
            Prix à titre indicatif et sujets à changement. Contactez-nous pour
            une soumission adaptée au nombre de postes de votre clinique ou
            entreprise.
          </p>
        </div>
      </section>

      <section className="section bg-cream">
        <div className="container">
          <div
            className="quote-block p-4 p-md-5 text-center"
            data-aos="zoom-in"
          >
            <h2 className="fw-900 mb-3" style={{ color: "#fff" }}>
              On vous aide à choisir le bon modèle
            </h2>
            <p className="mb-4" style={{ color: "rgba(255,255,255,0.85)" }}>
              Selon le nombre de postes, le volume d'appels et vos besoins en
              mobilité, on vous recommande l'équipement le plus adapté.
            </p>
            <Link
              to="/contact"
              className="btn btn-lg rounded-pill px-4"
              style={{
                background: "#fff",
                color: "var(--cpuc-red)",
                fontWeight: 700,
              }}
            >
              Demander une soumission
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
